import "vuetify/styles";
import { createVuetify } from "vuetify";

import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";

const vuetify = createVuetify({
  components,
  directives,
  defaults: {
    global: {
      style: {
        fontFamily: "'Be Vietnam Pro', sans-serif",
      },
    },
  },
  icons: {
    defaultSet: "mdi", 
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "light",
    options: { customProperties: true },
    themes: {
      light: {
        colors: {
          grey: "#f8f8fa",
          primary: "#363740",
          success:'#589662',
          blue: "#26A0FC",
          warning:'#e58f04',
          violet:'#7B00F7'
        },
      },
      dark: {
        colors: {
          grey: "#121212",
          primary: "#212121",
          blue: "#26A0FC",
          warning:'#e58f04',
          violet:'#7B00F7'
        },
      },
    },
  },
});

export default vuetify;